import React, {useEffect} from 'react';
import {MultiSelect} from 'primereact/multiselect';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import {observer} from 'mobx-react-lite'


const MultipleSelect = ({ store, prop, placeholder, options, label }) => {
  const [valid, setValid] = React.useState(false);
  useEffect(() => {
    if (store.was_validated && store[prop].length === 0) {
      setValid(false);
    } else {
      setValid(true);
    }
    
  }, [store.was_validated, store[prop]]);
  
  const itemTemplate = (option) => {
        return (
            <div className="flex align-items-center">
                <div>{option.icon} {option.name}</div>
            </div>
        );
    };
  
  return (
    <div className="card flex justify-content-center">
      <MultiSelect
        value={store[prop]}
        options={options}
        onChange={(e) => {
          store.setProperty(prop, e.value);
        }}
        itemTemplate={itemTemplate}
        optionLabel="name"
        optionValue="id"
        display="chip"
        placeholder={placeholder}
        className={`w-full ${valid ? '' : 'multi_invalid'}`}
      />
    </div>
  );
}

export default observer(MultipleSelect);
